module.exports = __webpack_public_path__ + "img/map_1791458173287_32800.dc73a2bc.jpg";